import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';

/**
 * SignUp component for user registration
 * @param {Object} props - Component props
 * @param {Function} props.onSuccess - Function to call on successful signup
 * @returns {JSX.Element} SignUp component
 */
const SignUp = ({ onSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);
  const { signUp, authError, domainRestriction } = useAuth();

  /**
   * Handle form submission
   * @param {Event} e - Form submit event
   */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setMessage(null);
    
    try {
      const { user, error } = await signUp({ email, password });
      
      if (error) {
        setError(error.message);
      } else {
        setMessage('Check your email for the confirmation link!');
        if (onSuccess) onSuccess();
      }
    } catch (err) {
      setError('An unexpected error occurred. Please try again.');
      console.error('Signup error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-form">
      <h2>Create Account</h2>
      {domainRestriction && (
        <p className="domain-restriction">Only @{domainRestriction} email addresses are allowed</p>
      )}
      
      {error && <div className="error">{error}</div>}
      {authError && <div className="error">{authError}</div>}
      {message && <div className="message">{message}</div>}
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={domainRestriction ? `yourname@${domainRestriction}` : "Email address"}
            required
            disabled={loading}
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            disabled={loading}
            minLength="6"
          />
        </div>
        
        <button type="submit" disabled={loading}>
          {loading ? 'Creating Account...' : 'Create Account'}
        </button>
      </form>
      
      <div className="auth-links">
        <p>
          Already have an account? <a href="#" onClick={() => onSuccess('login')}>Log In</a>
        </p>
      </div>
    </div>
  );
};

export default SignUp; 